import Main from '@/components/main/main-simplicity.vue'
const brandMenusRouters = [
  {
    name: 'brand',
    path: '/brand',
    meta: {
      hideInMenu: true,
      notCache: false,
      title: '基础数据',
      icon: 'ios-albums'
      // access: ['brand']
    },
    component: Main,
    children: [{
      name: 'brand-home',
      path: 'brand-home',
      meta: {
        hideInMenu: true,
        notCache: false
        // access: ['brand-home']
      },
      component: () => import('@/view/fts/brand/brand-home.vue')
    }]
  }
]
export default brandMenusRouters



// WEBPACK FOOTER //
// ./src/router/routers-menu-fts-brand.js